import { useLocation } from "react-router-dom";

export const menuData = [
    {
        id: 0,
        name: "Գլխավոր էջ",
        path: "/welcome"
    },
    {
        id: 1,
        name: "Ինֆորմատիկա",
        subcategories: ["Լաբորատոր աշխատանքներ"],
        path: "/information"
    },
    {
        id: 2,
        name: "Տեխնոլոգիա և ձեռնարկչություն",
        subcategories: ["Տեսական Նյութեր",],
        path: "/technology"
    },
    {
        id: 3,
        name: "Ֆիզիկա",
        subcategories: ["Տեսական Նյութեր", "Տեսանյութեր","Հղումներ",],
        path: "/physics"
    },
    {
        id: 4,
        name: "Քիմիա",
        subcategories: ["Տեսական Նյութեր","Տեսանյութեր", "Հղումներ", "Այլ"],
        path: "/chemistry"
    },
    {
        id: 5,
        name: "Կենսաբանություն",
        subcategories: ["Տեսական Նյութեր", "Տեսանյութեր","Հղումներ", ],
        path: "/biology"
    },
    {
        id: 6,
        name: "Աշխարհագրություն",
        subcategories: ["Տեսական Նյութեր", "Տեսանյութեր", "Հղումներ", "Այլ"],
        path: "/geography"

    },
    {
        id: 7,
        name: "Մաթեմատիկա",
        subcategories: ["Տեսական Նյութեր"],
        path: "/mathematics"

    },
];


export const useFindMenuId = () => {
    const location = useLocation();
    const matchedItem = menuData.find(item => item.path === location.pathname);

    return matchedItem ? matchedItem.id : null;
}


export const resetMenu = (navigate) => {
    sessionStorage.removeItem('selectedMenuId');
    sessionStorage.removeItem('selectedSubcategory');

    if ( navigate ) {
        navigate("/")
    }
};